import React, { useEffect, useState } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TableSortLabel, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getSuppliers } from "../services/api";

export default function Suppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [search, setSearch] = useState("");
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  useEffect(() => {
    getSuppliers().then(r => {
      const data = Array.isArray(r.data) ? r.data : [];
      setSuppliers(data);
    }).catch(() => setSuppliers([]));
  }, []);

  const handleSort = (col) => {
    if (orderBy === col) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(col);
      setOrder("asc");
    }
  };

  const filtered = suppliers
    .filter(s => (s.name || s.Name || "").toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      const aVal = (a[orderBy] || "").toLowerCase();
      const bVal = (b[orderBy] || "").toLowerCase();
      if (aVal < bVal) return order === "asc" ? -1 : 1;
      if (aVal > bVal) return order === "asc" ? 1 : -1;
      return 0;
    });

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h5" fontWeight={700}>Tedarikciler</Typography>
        <Typography variant="body2" color="text.secondary">Toplam: {suppliers.length}</Typography>
      </Box>

      <TextField
        fullWidth
        size="small"
        placeholder="Tedarikci ara..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }}
        sx={{ mb: 2 }}
      />

      <TableContainer component={Paper} sx={{ maxHeight: "calc(100vh - 220px)" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: 700 }}>
                <TableSortLabel active={orderBy === "name"} direction={orderBy === "name" ? order : "asc"} onClick={() => handleSort("name")}>
                  Tedarikçi Adı
                </TableSortLabel>
              </TableCell>
              <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: 700 }}>Telefon</TableCell>
              <TableCell sx={{ bgcolor: "#f5f5f5", fontWeight: 700 }}>
                <TableSortLabel active={orderBy === "balance"} direction={orderBy === "balance" ? order : "asc"} onClick={() => handleSort("balance")}>
                  Açık Bakiye
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">Tedarikci bulunamadi</TableCell>
              </TableRow>
            ) : (
              filtered.map((s, i) => (
                <TableRow key={i} hover>
                  <TableCell>{s.name || s.Name || "-"}</TableCell>
                  <TableCell>{s.phone || s.Phone || "-"}</TableCell>
                  <TableCell>{s.balance || s.Balance || s.acik_bakiye || "0.00"} TL</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}